module.exports = __webpack_public_path__ + "static/images/mc-2.646714c.png";